import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ApiResourceModule } from 'libraries/service/apiResource/apiResource.module';
import { ErrorTracingModule } from 'libraries/service/error-tracing/error-tracing.module';
import { PlainTextModule } from 'libraries/service/plainText/plaintText.module';
import { BreadcrumbIqbaModule } from "../breadcrumbIqba/breadcrumbIqba.module";
import { PropalService } from './propal.service';
import { SamResourceModule } from "libraries/service/resources/sam/samResource.module";
import { AirTripResourceModule } from "libraries/service/resources/airTrip/airTripResource.module";

@NgModule({
    imports: [
        HttpClientModule,
        PlainTextModule,
        ApiResourceModule,
        ErrorTracingModule,
        BreadcrumbIqbaModule,
        SamResourceModule,
        AirTripResourceModule,
    ],
    providers: [
        PropalService,
    ],
})
export class PropalModule {}
